module.exports = __webpack_public_path__ + "static/media/progress_bar_3_active.baa224f0.svg";